import type { ReactNode } from 'react';
import { RequiredMark } from '@/components/ui';

/**
 * 쿠폰 등록·수정 폼의 섹션(쿠폰 종류·기본 정보·할인 조건·쿠폰 예산·발급 설정…). QA-325:
 * - 섹션 제목과 안쪽 첫 항목 라벨을 위쪽 맞춤(제목 상단 여백 = 안쪽 상자 패딩 16px).
 * - 단계 구분: 섹션 사이 구분선, 제목은 굵게, 입력 상자는 옅은 배경 + 테두리.
 * - 입력칸이 화면 끝까지 늘어나지 않게 안쪽 너비를 제한.
 */
export const CouponFormSection = ({
  label,
  required,
  children,
  testId,
}: {
  label: string;
  /** 섹션 내 필드가 (조건부) 필수일 때 공통 RequiredMark 표기. */
  required?: boolean;
  children: ReactNode;
  testId?: string;
}) => (
  <div
    className="grid gap-3 border-t pt-6 first:border-t-0 first:pt-0 md:grid-cols-[160px_1fr] md:gap-6"
    style={{ borderColor: 'var(--divider-soft)' }}
    data-testid={testId}
  >
    <div className="md:pt-4" data-testid={testId ? `${testId}-label` : undefined}>
      <span className="text-[14px] font-semibold" style={{ color: 'var(--content-strong)' }}>
        {label}
        {required && <RequiredMark />}
      </span>
    </div>
    <div
      className="w-full max-w-[880px] rounded-lg border p-4"
      style={{ background: 'var(--surface-1)', borderColor: 'var(--divider-soft)' }}
    >
      {children}
    </div>
  </div>
);
